<template>
  <div style="margin-left: 40px;margin-right: 40px;">
    <div class="source">
      <el-row class="querypanel">
        <el-col :span="24">
          <el-col :span="12"><div class="queryinput">
            <el-input v-model="attrname" placeholder="请输入原始属性名称"></el-input>
          </div></el-col>
          <div class="queryinput">
            <el-button @click="addattr">添加原始属性</el-button>
            <el-button @click="editattr">编辑原始属性</el-button>
            <el-button @click="resetattr">复位</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row class="querypaneltrans">
        <el-col :span="15">
          <el-transfer
            filterable
            ref="gt_transfer"
            :titles="['原始属性', '分组属性']"
            filter-placeholder="请输入属性名称"
            v-model="rightdata"
            :data="leftdata"
            :props="{
                key: 'id',
                label: 'name'
             }"
            @change="handleChange">
          </el-transfer>
        </el-col>
        <el-col :span="9" style="padding-left: 20px;">
          <el-form label-width="80px" >
            <el-form-item label="归类选择">
              <el-select v-model="attrtype" @change="selectchange" placeholder="请选择归入类别" height="120px">
                <el-option
                  v-for="item in attrlist"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
            <el-button @click="saveattrtype">保存归类</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="tablepanel">
            <el-table
              :data="attrtypetb"
              fit>
              <el-table-column
                type="selection">
              </el-table-column>
              <el-table-column
                prop="attrname"
                label="名称"
              >
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                class-name="outopicondiv"
              >
                <template slot-scope="scope">
                  <div class="inopicondiv">
                    <i class="fa fa-trash-o opicon curpointer" v-on:click="removeattrtype(scope.$index, attrtypetb)"> 删除 </i>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
            ref="elpage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[size]"
            :page-size=size
            layout="total, sizes, prev, pager, next, jumper"
            :total=total>
          </el-pagination>
        </el-col>
      </el-row>
    </div><!--/.row-->
    <el-dialog title="原始产品属性编辑" :visible.sync="baseattrvisible">
      <div>
        <el-col :span="24">
          <el-col :span="12"><div class="queryinput">
            <el-input v-model="curattrname" placeholder="请输入需要修改的属性名称"></el-input>
          </div></el-col>
          <div class="queryinput">
            <el-button @click="changecurattr">更改属性名称</el-button>
          </div>
        </el-col>
        <el-table
          :data="baseattrtb"
          fit>
          <el-table-column
            prop="name"
            label="名称"
          >
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            class-name="outopicondiv"
          >
            <template slot-scope="scope">
              <div class="inopicondiv">
                <i class="fa fa-eye opicon curpointer" v-on:click="changeattrname(scope.$index, baseattrtb)"> 编辑 </i>

                <i class="fa fa-trash-o opicon curpointer" v-on:click="removebaseattr(scope.$index, baseattrtb)"> 删除 </i>
              </div>
            </template>
          </el-table-column>
        </el-table>

      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import { Loading } from 'element-ui'
import '../../../static/css/my.css'
import ElForm from '../../../node_modules/element-ui/packages/form/src/form'
Vue.prototype.$http = axios
var that
var curpagedata
var curdata
export default {
  components: {ElForm},
  name: 'GoodsAttr',
  data () {
    return {
      currentPage: 1,
      total: 0,
      curpage: 1,
      curattrname: '',
      selectattr: '',
      size: 10,
      attrtype: '',
      khid: '',
      attrname: '',
      leftdata: [],
      rightdata: [],
      baseattrtb: [],
      attrtypetb: [],
      baseattrvisible: false,
      attrlist: [{
        value: '0',
        label: '基础属性'
      }, {
        value: '1',
        label: '规格属性'
      }, {
        value: '2',
        label: '特殊属性'
      }]
    }
  },
  mounted: function () {
    let loadingInstance1 = Loading.service({ fullscreen: true })
    var menudata = this.$parent.$children[1].$refs.menu_data
    console.log(menudata)
    menudata.activeIndex = '116'
    var v = getCookie('cusid')
    this.khid = v
    that = this
    if (that.khid === null) {
      loadingInstance1.close()
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
      loadingInstance1.close()
      var idstr = 'cusid = ' + this.khid
      that = this
      that.size = 5
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/qga',
        method: 'post',
        data: {
          whereinfo: {'String': idstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            loadingInstance1.close()
            console.log(res.data.data)
            that.leftdata = JSON.parse(res.data.data)
          } else {
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  },
  methods: {
    changecurattr () {
      console.log(this.selectattr)
      var adata
      adata = {
        attrid: parseInt(this.selectattr.id.Int64),
        attrname: {'String': this.curattrname, Valid: true}
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/pcai',
        method: 'post',
        data: adata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log('已获取网络数据')
          if (res.data.success === true) {
            that.$message({
              type: 'success',
              message: '更新成功！'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    handleSizeChange (val) {
      console.log('每页' + val + '条')
    },
    handleCurrentChange (val) {
      console.log('当前页: ' + val)
      this.curpage = val
      curpagedata.splice(0, this.size)
      for (var i = (that.curpage - 1) * this.size; i < (that.curpage - 1) * this.size + this.size; i++) {
        if (curdata[i] != null) {
          curpagedata.push(curdata[i])
        }
      }
    },
    resetattr () {
      let loadingInstance1 = Loading.service({ fullscreen: true })
      var idstr = 'cusid = ' + this.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/qga',
        method: 'post',
        data: {
          whereinfo: {'String': idstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          loadingInstance1.close()
          if (res.data.success) {
            console.log(res.data.data)
            that.leftdata = JSON.parse(res.data.data)
          } else {
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    addattr () {
      let loadingInstance1 = Loading.service({ fullscreen: true })
      if (this.attrname === null || this.attrname === '') {
        that.$message({
          type: 'info',
          message: '基础属性需要填写！！'
        })
      } else {
        var adata
        adata = {
          name: this.attrname,
          cusid: parseInt(this.khid)
        }
        that.$http({
          url: 'https://api.sqnetsoft.cn/goods/aauga',
          method: 'post',
          data: adata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log('已获取网络数据')
            if (res.data.success === true) {
              var idstr = 'cusid = ' + that.khid
              that.$http({
                url: 'https://api.sqnetsoft.cn/goods/qga',
                method: 'post',
                data: {
                  whereinfo: {'String': idstr, Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  console.log(res)
                  if (res.data.success) {
                    loadingInstance1.close()
                    that.leftdata = JSON.parse(res.data.data)
                    that.$message({
                      type: 'success',
                      message: '添加成功！'
                    })
                  } else {
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    editattr () {
      let loadingInstance1 = Loading.service({ fullscreen: true })
      this.baseattrvisible = true
      var idstr = 'cusid = ' + this.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/qga',
        method: 'post',
        data: {
          whereinfo: {'String': idstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          loadingInstance1.close()
          console.log(res)
          if (res.data.success) {
            console.log(res.data.data)
            that.baseattrtb = JSON.parse(res.data.data)
          } else {
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    changeattrname (index, data) {
      console.log(data[index])
      this.selectattr = data[index]
      this.curattrname = data[index].name
    },
    removebaseattr (index, data) {
      let loadingInstance1 = Loading.service({ fullscreen: true })
      var curselectdata = data[index]
      var dataindex = data.findIndex(d => d.id === curselectdata.id)
      // 移除该条数据
      data.splice(dataindex, 1)
      console.log(curselectdata)
      var qstr = 'id=' + curselectdata.id.Int64
      // 提交到后台服务器做处理
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/dga',
        method: 'post',
        data: {
          whereinfo: {'String': qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          loadingInstance1.close()
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '删除成功'
            })
          } else {
            that.$message({
              type: 'error',
              message: '删除失败'
            })
          }
        })
        .catch(function (error) {
          that.$message({
            type: 'error',
            message: '删除失败'
          })
          console.log('error' + error)
        })
    },
    handleChange (value, direction, movedKeys) {
      console.log(value, direction, movedKeys)
    },
    saveattrtype () {
      console.log(this.leftdata)
      console.log(this.rightdata)
      console.log(this.attrtype)
      if (this.attrtype === '' || this.attrtype === null) {
        that.$message({
          type: 'info',
          message: '请先选择分类'
        })
      } else {
        var attlist = []
        for (var index in this.rightdata) {
          var subdata = this.rightdata[index]
          var dataindex = this.leftdata.findIndex(d => d.id.Int64 === subdata.Int64)
          var subdataname = this.leftdata[dataindex]
          if (subdata.Valid) {
            console.log(subdata.Int64)
            var adata
            adata = {
              attrtypeid: parseInt(this.attrtype),
              attrid: parseInt(subdata.Int64),
              attrname: subdataname.name,
              cusid: parseInt(this.khid)
            }
            attlist.push(adata)
          }
        }
        console.log(attlist)
        let loadingInstance1 = Loading.service({ fullscreen: true })
        that.$http({
          url: 'https://api.sqnetsoft.cn/goods/paaugag',
          method: 'post',
          data: attlist,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              var idstr = 'cusid = ' + that.khid + ' and attr_type_id=' + that.attrtype
              that.$http({
                url: 'https://api.sqnetsoft.cn/goods/qgag',
                method: 'post',
                data: {
                  whereinfo: {'String': idstr, Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  console.log(res)
                  if (res.data.success) {
                    loadingInstance1.close()
                    console.log(res.data.data)
                    that.attrtypetb = JSON.parse(res.data.data)
                    that.$message({
                      type: 'success',
                      message: '已保存至分类'
                    })
                  } else {
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            } else {
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
      this.rightdata = []
    },
    selectchange () {
      let loadingInstance1 = Loading.service({ fullscreen: true })
      var idstr = 'cusid = ' + that.khid + ' and attr_type_id=' + that.attrtype
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/qgag',
        method: 'post',
        data: {
          whereinfo: {'String': idstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          loadingInstance1.close()
          if (res.data.success) {
            console.log(res.data.data)
            that.attrtypetb = JSON.parse(res.data.data)
            that.$message({
              type: 'success',
              message: '读取属性分类完毕'
            })
          } else {
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    seeattrtype () {
    },
    removeattrtype (index, data) {
      let loadingInstance1 = Loading.service({ fullscreen: true })
      var curselectdata = data[index]
      var dataindex = data.findIndex(d => d.id === curselectdata.id)
      // 移除该条数据
      data.splice(dataindex, 1)
      console.log(curselectdata)
      var qstr = 'id=' + curselectdata.id
      // 提交到后台服务器做处理
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/dgag',
        method: 'post',
        data: {
          whereinfo: {'String': qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          loadingInstance1.close()
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '删除成功'
            })
          } else {
            that.$message({
              type: 'error',
              message: '删除失败'
            })
          }
        })
        .catch(function (error) {
          that.$message({
            type: 'error',
            message: '删除失败'
          })
          console.log('error' + error)
        })
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/goods/GoodsAttr.vue